import { Queue } from '@tf/queue';
import { map, Observable } from '@tf/observable';
var InMemoryCache = /** @class */ (function () {
    function InMemoryCache() {
        this.cache = {};
        this.queue = new Queue();
        this.timeouts = {};
    }
    InMemoryCache.instance = function () {
        if (this._instance == null) {
            this._instance = new InMemoryCache();
        }
        return this._instance;
    };
    InMemoryCache.prototype.clear = function () {
        this.cache = {};
        this.clearAllTimeouts();
        this.update();
    };
    InMemoryCache.prototype.evict = function (key) {
        delete this.cache[key];
        this.clearTimeout(key);
        this.update();
    };
    InMemoryCache.prototype.get = function (key) {
        return this.cache[key];
    };
    InMemoryCache.prototype.observe = function (key) {
        var observedValue$;
        if (key != null) {
            observedValue$ = new Observable(this.queue).pipe(map(function (cache) { return cache[key]; }));
        }
        else {
            observedValue$ = new Observable(this.queue);
        }
        return observedValue$;
    };
    InMemoryCache.prototype.set = function (key, value, ttl) {
        this.cache[key] = value;
        this.update();
        this.waitForTimeout(key, ttl);
        return value;
    };
    InMemoryCache.prototype.clearAllTimeouts = function () {
        Object.values(this.timeouts).forEach(function (timeout) {
            clearTimeout(timeout);
        });
        this.timeouts = {};
    };
    InMemoryCache.prototype.clearTimeout = function (key) {
        if (this.timeouts[key] != null) {
            clearTimeout(this.timeouts[key]);
            delete this.timeouts[key];
        }
    };
    InMemoryCache.prototype.update = function () {
        this.queue.call(this.cache);
    };
    InMemoryCache.prototype.waitForTimeout = function (key, ttl) {
        var _this = this;
        this.clearTimeout(key);
        this.timeouts[key] = setTimeout(function () {
            _this.evict(key);
        }, ttl);
    };
    return InMemoryCache;
}());
export { InMemoryCache };
//# sourceMappingURL=data:application/json;base64,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